import { render } from "./UserPics.vue?vue&type=template&id=2ecea73e"
import script from "./UserPics.vue?vue&type=script&lang=js"
export * from "./UserPics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__